import React, { useMemo } from 'react';
import Icon from '../../../components/AppIcon';
import { computeYearTaxSnapshot } from '../../../services/planningTax';

const BilanSummary = ({ assets = [], debts = [], revenues = [], entities = [], formatCurrency }) => {
  const totalAssets = assets.reduce((s, a) => s + (parseFloat(a.currentBalance) || 0), 0);
  const totalDebts = debts.reduce((s, d) => s + (parseFloat(d.currentBalance) || 0), 0);
  const netWorth = totalAssets - totalDebts;

  const taxSnapshot = useMemo(
    () => computeYearTaxSnapshot({ entities, assets, debts, revenues }),
    [entities, assets, debts, revenues],
  );

  const monthlyRevenue = taxSnapshot.monthlyRevenue;
  const monthlyDebtPayment = taxSnapshot.monthlyDebtPayment;
  const monthlyRevenueAfterTax = taxSnapshot.monthlyRevenueAfterTax;
  const monthlyTax = taxSnapshot.monthlyTax;
  const monthlyCashflowAfterTax = taxSnapshot.monthlyCashflowAfterTax;

  const cards = [
    { label: 'Actifs totaux', value: totalAssets, icon: 'TrendingUp', color: 'var(--color-success)' },
    { label: 'Dettes totales', value: totalDebts, icon: 'TrendingDown', color: 'var(--color-destructive)' },
    { label: 'Valeur nette', value: netWorth, icon: 'DollarSign', color: netWorth >= 0 ? 'var(--color-primary)' : 'var(--color-destructive)' },
    { label: 'Revenu mensuel brut', value: monthlyRevenue, icon: 'Wallet', color: 'var(--color-success)' },
    { label: 'Impôt mensuel estimé', value: monthlyTax, icon: 'Receipt', color: '#ef4444' },
    { label: 'Cashflow net (après impôt)', value: monthlyCashflowAfterTax, icon: 'Activity', color: monthlyCashflowAfterTax >= 0 ? 'var(--color-success)' : 'var(--color-destructive)' },
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-5 md:p-6" data-testid="bilan-summary">
      <h2 className="text-lg font-semibold text-foreground flex items-center gap-2 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
        <Icon name="PieChart" size={20} className="text-primary" />
        Sommaire financier
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {cards.map(card => (
          <div key={card.label} data-testid={`summary-${card.label.toLowerCase().replace(/\s/g, '-')}`}>
            <div className="flex items-center gap-1.5 mb-1">
              <Icon name={card.icon} size={14} style={{ color: card.color }} />
              <p className="text-xs text-muted-foreground" style={{ fontFamily: 'var(--font-caption)' }}>{card.label}</p>
            </div>
            <p className="text-lg font-semibold" style={{ color: card.color, fontFamily: 'var(--font-data)' }}>
              {formatCurrency(card.value)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BilanSummary;
